import { render, staticRenderFns } from "./Statics.vue?vue&type=template&id=5bb98c8f&scoped=true&"
import script from "./Statics.vue?vue&type=script&lang=js&"
export * from "./Statics.vue?vue&type=script&lang=js&"
import style0 from "./Statics.vue?vue&type=style&index=0&id=5bb98c8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb98c8f",
  null
  
)

export default component.exports